import i18n from 'utils/i18n'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  SEARCH_USERS,
  RADIO_LIST,
  SCORE,
  INTERVAL,
  PRICE_INTERVAL,
  SWITCHER,
  RHEOSTAT,
  MULTISELECT_SWITCHER,
  offersFiltersTitle as baseOffersFiltersTitle,
  databaseFiltersTitle,
  databaseFiltersName,
  databaseFiltersKey,
} from 'utils/consts'
import type {
  FiltersCollection,
  FiltersCollectionItem,
} from '../filtersCollectionsRegistry'

// Единый словарь записей фильтров database. Коллекции собираются
// из этого словаря по filterName.
export const getDatabaseFilterEntries = (): Record<
  string,
  FiltersCollectionItem
> => ({
  [databaseFiltersName.retailPriceFilter]: {
    type: filterTypes[PRICE_INTERVAL],
    title: i18n.t(databaseFiltersTitle.retailPriceFilter),
    filterName: databaseFiltersName.retailPriceFilter,
    apiFilterName: databaseFiltersKey().retailPriceFilter,
    defaultIntervalKey: 'retailPriceInterval',
  },
  [databaseFiltersName.onlyLatestVintageFilter]: {
    type: filterTypes[SWITCHER],
    title: i18n.t(databaseFiltersTitle.onlyLatestVintageFilter),
    filterName: databaseFiltersName.onlyLatestVintageFilter,
    apiFilterName: databaseFiltersKey().onlyLatestVintageFilter,
  },
  [databaseFiltersName.hasBottleImageFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasBottleImageFilter),
    filterName: databaseFiltersName.hasBottleImageFilter,
    apiFilterName: databaseFiltersKey().hasBottleImageFilter,
  },
  [databaseFiltersName.adminPackshotImageFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.adminPackshotImageFilter),
    filterName: databaseFiltersName.adminPackshotImageFilter,
    apiFilterName: databaseFiltersKey().adminPackshotImageFilter,
  },
  [databaseFiltersName.hasFrontLabelImageFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasFrontLabelImageFilter),
    filterName: databaseFiltersName.hasFrontLabelImageFilter,
    apiFilterName: databaseFiltersKey().hasFrontLabelImageFilter,
  },
  [databaseFiltersName.adminFrontLabelImageFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.adminFrontLabelImageFilter),
    filterName: databaseFiltersName.adminFrontLabelImageFilter,
    apiFilterName: databaseFiltersKey().adminFrontLabelImageFilter,
  },
  [databaseFiltersName.hasBackLabelImageFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasBackLabelImageFilter),
    filterName: databaseFiltersName.hasBackLabelImageFilter,
    apiFilterName: databaseFiltersKey().hasBackLabelImageFilter,
  },
  [databaseFiltersName.adminBackLabelImageFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.adminBackLabelImageFilter),
    filterName: databaseFiltersName.adminBackLabelImageFilter,
    apiFilterName: databaseFiltersKey().adminBackLabelImageFilter,
  },
  [databaseFiltersName.hasVerifiedRepresentativeFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasVerifiedRepresentativeFilter),
    filterName: databaseFiltersName.hasVerifiedRepresentativeFilter,
    apiFilterName: databaseFiltersKey().hasVerifiedRepresentativeFilter,
  },
  [databaseFiltersName.hasWebsiteFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasWebsiteFilter),
    filterName: databaseFiltersName.hasWebsiteFilter,
    apiFilterName: databaseFiltersKey().hasWebsiteFilter,
  },
  [databaseFiltersName.hasEmailFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasEmailFilter),
    filterName: databaseFiltersName.hasEmailFilter,
    apiFilterName: databaseFiltersKey().hasEmailFilter,
  },
  [databaseFiltersName.hasPhoneFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.hasPhoneFilter),
    filterName: databaseFiltersName.hasPhoneFilter,
    apiFilterName: databaseFiltersKey().hasPhoneFilter,
  },
  [databaseFiltersName.countryFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(baseOffersFiltersTitle.wineCountryFilter),
    filterName: databaseFiltersName.countryFilter,
    apiFilterName: databaseFiltersKey().countryFilter,
  },
  [databaseFiltersName.countryFilter2]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.countryFilter),
    filterName: databaseFiltersName.countryFilter2,
    apiFilterName: databaseFiltersKey().countryFilter,
  },
  [databaseFiltersName.usersFilter]: {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(databaseFiltersTitle.usersFilter),
    filterName: databaseFiltersName.usersFilter,
    apiFilterName: databaseFiltersKey().usersFilter,
  },
  [databaseFiltersName.creationDateFilter]: {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(databaseFiltersTitle.creationDateFilter),
    filterName: databaseFiltersName.creationDateFilter,
    apiFilterName: databaseFiltersKey().creationDateFilter,
  },
  [databaseFiltersName.lastUpdateFilter]: {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(databaseFiltersTitle.lastUpdateFilter),
    filterName: databaseFiltersName.lastUpdateFilter,
    apiFilterName: databaseFiltersKey().lastUpdateFilter,
  },
  [databaseFiltersName.sourceFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.sourceFilter),
    filterName: databaseFiltersName.sourceFilter,
    apiFilterName: databaseFiltersKey().sourceFilter,
  },
  [databaseFiltersName.checkedByFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.checkedByFilter),
    filterName: databaseFiltersName.checkedByFilter,
    apiFilterName: databaseFiltersKey().checkedByFilter,
  },
  [databaseFiltersName.invalidRecordFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.invalidRecordFilter),
    filterName: databaseFiltersName.invalidRecordFilter,
    apiFilterName: databaseFiltersKey().invalidRecordFilter,
  },
  [databaseFiltersName.legalEntityFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.legalEntityFilter),
    filterName: databaseFiltersName.legalEntityFilter,
    apiFilterName: databaseFiltersKey().legalEntityFilter,
  },
  [databaseFiltersName.producerFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.producerFilter),
    filterName: databaseFiltersName.producerFilter,
    apiFilterName: databaseFiltersKey().producerFilter,
  },
  [databaseFiltersName.registrationFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.registrationFilter),
    filterName: databaseFiltersName.registrationFilter,
    apiFilterName: databaseFiltersKey().registrationFilter,
  },
  [databaseFiltersName.producerWWLFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.producerWWLFilter),
    filterName: databaseFiltersName.producerWWLFilter,
    apiFilterName: databaseFiltersKey().producerWWLFilter,
  },
  [databaseFiltersName.euGITypeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.euGITypeFilter),
    filterName: databaseFiltersName.euGITypeFilter,
    apiFilterName: databaseFiltersKey().euGITypeFilter,
  },
  [databaseFiltersName.nationalGITypeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.nationalGITypeFilter),
    filterName: databaseFiltersName.nationalGITypeFilter,
    apiFilterName: databaseFiltersKey().nationalGITypeFilter,
  },
  [databaseFiltersName.wineRegionEUFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.wineRegionEUFilter),
    filterName: databaseFiltersName.wineRegionEUFilter,
    apiFilterName: databaseFiltersKey().wineRegionEUFilter,
  },
  [databaseFiltersName.geoIndicationFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.geoIndicationFilter),
    filterName: databaseFiltersName.geoIndicationFilter,
    apiFilterName: databaseFiltersKey().geoIndicationFilter,
  },
  [databaseFiltersName.specialClassificationFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.specialClassificationFilter),
    filterName: databaseFiltersName.specialClassificationFilter,
    apiFilterName: databaseFiltersKey().specialClassificationFilter,
  },
  [databaseFiltersName.wineTypeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.wineTypeFilter),
    filterName: databaseFiltersName.wineTypeFilter,
    apiFilterName: databaseFiltersKey().wineTypeFilter,
  },
  [databaseFiltersName.wineColourFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.wineColourFilter),
    filterName: databaseFiltersName.wineColourFilter,
    apiFilterName: databaseFiltersKey().wineColourFilter,
  },
  [databaseFiltersName.sweetnessTypeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.sweetnessTypeFilter),
    filterName: databaseFiltersName.sweetnessTypeFilter,
    apiFilterName: databaseFiltersKey().sweetnessTypeFilter,
  },
  [databaseFiltersName.vintageFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.vintageFilter),
    filterName: databaseFiltersName.vintageFilter,
    apiFilterName: databaseFiltersKey().vintageFilter,
  },
  [databaseFiltersName.bottleSizeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.bottleSizeFilter),
    filterName: databaseFiltersName.bottleSizeFilter,
    apiFilterName: databaseFiltersKey().bottleSizeFilter,
  },
  [databaseFiltersName.packageTypeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.packageTypeFilter),
    filterName: databaseFiltersName.packageTypeFilter,
    apiFilterName: databaseFiltersKey().packageTypeFilter,
  },
  [databaseFiltersName.grapesFilter]: {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(databaseFiltersTitle.grapesFilter),
    filterName: databaseFiltersName.grapesFilter,
    apiFilterName: databaseFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: databaseFiltersName.monocepageFilter,
    switchTitle: i18n.t(databaseFiltersTitle.monocepageFilter),
    switchApiFilterName: databaseFiltersKey().monocepageFilter,
  },
  [databaseFiltersName.certificatesFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.certificatesFilter),
    filterName: databaseFiltersName.certificatesFilter,
    apiFilterName: databaseFiltersKey().certificatesFilter,
  },
  [databaseFiltersName.alcoholLevelFilter]: {
    type: filterTypes[INTERVAL],
    title: i18n.t(databaseFiltersTitle.alcoholLevelFilter),
    filterName: databaseFiltersName.alcoholLevelFilter,
    apiFilterName: databaseFiltersKey().alcoholLevelFilter,
    defaultIntervalKey: 'alcoholLevels',
  },
  [databaseFiltersName.cellarDoorPriceFilter]: {
    type: filterTypes[PRICE_INTERVAL],
    title: i18n.t(databaseFiltersTitle.cellarDoorPriceFilter),
    filterName: databaseFiltersName.cellarDoorPriceFilter,
    apiFilterName: databaseFiltersKey().cellarDoorPriceFilter,
    defaultIntervalKey: 'priceInterval',
  },
  [databaseFiltersName.wwlRatingFilter]: {
    type: filterTypes[SCORE],
    title: i18n.t(databaseFiltersTitle.wwlRatingFilter),
    filterName: databaseFiltersName.wwlRatingFilter,
    apiFilterName: databaseFiltersKey().wwlRatingFilter,
  },
  [databaseFiltersName.brandFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.brandFilter),
    filterName: databaseFiltersName.brandFilter,
    apiFilterName: databaseFiltersKey().brandFilter,
  },
  [databaseFiltersName.additionalNameFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.additionalNameFilter),
    filterName: databaseFiltersName.additionalNameFilter,
    apiFilterName: databaseFiltersKey().additionalNameFilter,
  },
  [databaseFiltersName.withAdditionalNameFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.withAdditionalNameFilter),
    filterName: databaseFiltersName.withAdditionalNameFilter,
    apiFilterName: databaseFiltersKey().withAdditionalNameFilter,
  },
  [databaseFiltersName.synonymsFilter]: {
    type: filterTypes[SWITCHER],
    title: i18n.t(databaseFiltersTitle.synonymsFilter),
    filterName: databaseFiltersName.synonymsFilter,
    apiFilterName: databaseFiltersKey().synonymsFilter,
  },
  [databaseFiltersName.havePublicReviewsFilter]: {
    type: filterTypes[SWITCHER],
    title: i18n.t(databaseFiltersTitle.hasReviews),
    filterName: databaseFiltersName.havePublicReviewsFilter,
    apiFilterName: databaseFiltersKey().havePublicReviewsFilter,
  },
  [databaseFiltersName.parentGeoIndicationFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.parentGeoIndicationFilter),
    filterName: databaseFiltersName.parentGeoIndicationFilter,
    apiFilterName: databaseFiltersKey().parentGeoIndicationFilter,
  },
  [databaseFiltersName.wineTerritoryTypeFilter]: {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(databaseFiltersTitle.wineTerritoryTypeFilter),
    filterName: databaseFiltersName.wineTerritoryTypeFilter,
    apiFilterName: databaseFiltersKey().wineTerritoryTypeFilter,
  },
  [databaseFiltersName.dateStartFilter]: {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(databaseFiltersTitle.dateStartFilter),
    filterName: databaseFiltersName.dateStartFilter,
    apiFilterName: databaseFiltersKey().dateStartFilter,
    maxDate: null,
  },
  [databaseFiltersName.dateEndFilter]: {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(databaseFiltersTitle.dateEndFilter),
    filterName: databaseFiltersName.dateEndFilter,
    apiFilterName: databaseFiltersKey().dateEndFilter,
    maxDate: null,
  },
  [databaseFiltersName.participantsFilter]: {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(databaseFiltersTitle.participantsFilter),
    filterName: databaseFiltersName.participantsFilter,
    apiFilterName: databaseFiltersKey().participantsFilter,
  },
  [databaseFiltersName.exhibitionTypeFilter]: {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(databaseFiltersTitle.exhibitionTypeFilter),
    filterName: databaseFiltersName.exhibitionTypeFilter,
    apiFilterName: databaseFiltersKey().exhibitionTypeFilter,
  },
})

// Утилита: вернуть записи в указанном порядке, пропустив отсутствующие.
export const pickEntries = (names: string[]): FiltersCollection => {
  const entries = getDatabaseFilterEntries()
  return names
    .map(name => entries[name])
    .filter((entry): entry is FiltersCollectionItem => Boolean(entry))
}
